<template>
  <header
    v-if="!!title || !!subtitle"
    :class="bemBlock"
    :style="cssCustomProps"
  >
    <p
      v-if="!!subtitle"
      :class="bemElement('subtitle')"
    >
      {{ subtitle }}
    </p>
    <h2
      v-if="!!title"
      :class="bemElement('title')"
    >
      <span>
        {{ title }}
      </span>
    </h2>
  </header>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseTitleSubtitle',

  mixins: [
    bemClassesMixin,
  ],

  props: {
    color: {
      type: String,
      default: '',
      required: false,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
    subtitle: {
      type: String,
      default: '',
      required: false,
    },
  },

  computed: {
    cssCustomProps() {
      return {
        '--title-subtitle-color': this.color ?? '',
      };
    },
  },
};
</script>
